import isServerSide from '@helpers/misc/isServerSide'
import getQueryParam from '@packages/justo-parts/lib/helpers/getQueryParam'

import generateId from '../misc/generateId'

export default function getDeviceId() {
  if (isServerSide()) return null

  const paramDeviceId = getQueryParam('deviceId')
  if (paramDeviceId) {
    localStorage.setItem('deviceId', paramDeviceId)
    return paramDeviceId
  }

  const savedId = localStorage?.getItem('deviceId')
  if (savedId) return savedId

  const generatedId = generateId(50)

  localStorage?.setItem('deviceId', generatedId)
  return generatedId
}
